<template>
    <section class="appointment-calendar availability-calendar">
        <header class="appointment-calendar__weekdays">
            <h5 v-for="(weekday, index) in weekDays" :key="index" class="appointment-calendar__weekday">
                {{ weekday }}
            </h5>
        </header>

        <ol class="appointment-calendar__days">
            <li v-for="(day, index) in monthDaysWithoutEndPadding" :key="index" :class="calendarDayClass(day)">
                <div class="availability-calendar-day-small-center">
                    {{ day ? day.day : '' }}
                </div>
            </li>
        </ol>
    </section>
</template>

<script>
    import dayjs from 'dayjs'
    import CalendarMixin from 'mixins/CalendarMixin'

    export default {
        mixins: [CalendarMixin],

        methods: {
            calendarDayClass(day) {
                return {
                    'appointment-calendar__day': true,
                    'availability-calendar-day-small': true,
                    'availability-calendar-day-small-center--selected': this.checkTodayDate(day),
                }
            },

            checkTodayDate(day) {
                if (day) {
                    const today = dayjs().startOf('day')
                    return day.date.$d.toString() === today.$d.toString()
                }
                return false
            },
        },
    }
</script>
